var image_viewer_rtlignore_default = {
  "fontElementMap": "Ivfri",
  "imageContainer": "Lxy8k",
  "expandContainer": "mGgpG",
  "expandIcon": "_32JuH",
  "pointer": "_0ANgd",
  "imageWrapper": "ccajr",
  "imageRatio": "g3I9r",
  "image": "_3d4W5",
  "imageOverlay": "lGRDy",
  "imagePreload": "bdAK4",
  "imageHighres": "ltSDh",
  "onlyHighRes": "ViFaN",
  "image_loading": "Q2MDf"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
